export const detectIsInIframe = (): boolean => {
  if (typeof window === 'undefined') return false;

  // `window.parent !== window` is the cross-origin-safe check.
  // Accessing `window.top` in a cross-origin iframe causes Chrome to log a
  // "Blocked a frame" security warning even when the access is caught.
  // `window.parent` returns the parent WindowProxy without any security error —
  // it equals `window` only in a top-level context.
  return window.parent !== window;
};
